import React, { useEffect, useMemo } from "react";
import { Card, Col, Row } from "react-bootstrap";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import ExcuseDutyTable from "../components/tables/ExcuseDutyTable";
import useManageExcuseDuty from "../hooks/patientDashboard/useManageExcuseDuty";

export default function ExcuseDuty() {
  const { loading, duties, handleFetchExcuseDuties, handlePrintExcuseDuty } = useManageExcuseDuty();
  const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
  const [skin, setSkin] = React.useState(currentSkin);

  const switchSkin = (mode) => {
    if (mode === "dark") {
      const btnWhite = document.getElementsByClassName("btn-white");
      for (const btn of btnWhite) {
        btn.classList.add("btn-outline-primary");
        btn.classList.remove("btn-white");
      }
      return;
    }
    const btnOutlinePrimary = document.getElementsByClassName("btn-outline-primary");
    for (const btn of btnOutlinePrimary) {
      btn.classList.remove("btn-outline-primary");
      btn.classList.add("btn-white");
    }
  };

  switchSkin(skin);
  useEffect(() => { switchSkin(skin); }, [skin]);

  useEffect(() => {
    handleFetchExcuseDuties(1, 10);
  }, []);

  const stats = useMemo(() => {
    const total = Array.isArray(duties) ? duties.length : 0;
    const pending = duties.filter((d) => (d.status || "").toLowerCase() === "pending").length;
    const accepted = duties.filter((d) => (d.status || "").toLowerCase() === "accepted").length;
    const rejected = duties.filter((d) => (d.status || "").toLowerCase() === "rejected").length;
    return { total, pending, accepted, rejected };
  }, [duties]);

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-4 p-lg-5">
        <div className="data-page-hero document-hero">
          <div className="data-page-copy">
            <span className="data-page-kicker">Excuse Duty</span>
            <h2>Access your excuse duty certificates anytime</h2>
            <p>Review issued certificates, check status, and print accepted ones on the official hospital letterhead.</p>
          </div>
          <div className="data-page-stats">
            <div className="data-page-stat">
              <small>Total</small>
              <strong>{stats.total}</strong>
            </div>
            <div className="data-page-stat">
              <small>Pending</small>
              <strong>{stats.pending}</strong>
            </div>
            <div className="data-page-stat">
              <small>Accepted</small>
              <strong>{stats.accepted}</strong>
            </div>
            <div className="data-page-stat">
              <small>Rejected</small>
              <strong>{stats.rejected}</strong>
            </div>
          </div>
        </div>

        <Row className="g-5">
          <Col xl>
            <Card className="data-panel">
              <ExcuseDutyTable data={duties} loading={loading} onPrint={handlePrintExcuseDuty} />
            </Card>
          </Col>
          <Col xl="3" className="d-none d-xl-block">
            <div className="data-sidebar-stack">
              <div className="data-sidebar-card">
                <h6 className="data-sidebar-title">About Excuse Duty</h6>
                <div className="data-sidebar-item">
                  <div className="data-cell-title">Read-only</div>
                  <div className="data-cell-meta">Certificates are issued by your doctor and cannot be edited by patients.</div>
                </div>
                <div className="data-sidebar-item">
                  <div className="data-cell-title">Printing</div>
                  <div className="data-cell-meta">Only <strong>accepted</strong> certificates can be printed. You will be asked to confirm before printing.</div>
                </div>
                <div className="data-sidebar-item">
                  <div className="data-cell-title">Letterhead</div>
                  <div className="data-cell-meta">Printed certificate uses the official Deda Hospital letterhead (A4).</div>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <Footer />
      </div>
    </React.Fragment>
  );
}
